import { useOptimisticUpdateMutation } from "../../../hooks/useOptimisticUpdateMutation";
import {
  ExerciseAssetStatus,
  ExerciseTagDto,
  IUpdateExerciseAssetCommand,
  PaginatedListOfExerciseAssetDto,
} from "@growth-machine-llc/stridist-api-client";
import ExerciseAssetsService from "../../../services/ExerciseAssetsService";
import { COACH_EXERCISE_LIBRARY_ASSETS_QUERY_KEY } from "../ExercisesTableScreen";
import { INVALIDATE_KEYS_ON_EXERCISE_LIST_UPDATE } from "./useArchiveRestoreLibraryExercise";
import { useQueryClient } from "@tanstack/react-query";

export const UPDATE_EXERCISE_MESSAGE = "Update library exercise";

export function useUpdateLibraryExercise(
  exerciseTags?: ExerciseTagDto[],
  successMessage: string = UPDATE_EXERCISE_MESSAGE,
  updateWithApprovedExercise: boolean = false,
) {
  const queryClient = useQueryClient();
  return useOptimisticUpdateMutation({
    queryKey: [COACH_EXERCISE_LIBRARY_ASSETS_QUERY_KEY],
    mutationFn: ExerciseAssetsService.updateExerciseAsset,
    successToastMessage: successMessage,
    optimisticUpdater: {
      updateFn: (
        oldData: PaginatedListOfExerciseAssetDto,
        variables: IUpdateExerciseAssetCommand,
      ) => {
        if (updateWithApprovedExercise) {
          return {
            ...oldData,
            items: oldData.items.filter((item) => item.id !== variables.id),
          } as PaginatedListOfExerciseAssetDto;
        }

        const updatedItems = oldData.items.map((item) =>
          item.id === variables.id
            ? {
                ...item,
                ...variables,
                tags: exerciseTags !== undefined ? exerciseTags : item.tags,
              }
            : item,
        );

        return {
          ...oldData,
          items: updatedItems,
        } as PaginatedListOfExerciseAssetDto;
      },
    },
    options: {
      onSuccess: () => {
        if (updateWithApprovedExercise) {
          queryClient.invalidateQueries({
            queryKey: [
              COACH_EXERCISE_LIBRARY_ASSETS_QUERY_KEY,
              {
                status: ExerciseAssetStatus.PUBLISHED,
              },
            ],
          });
        }

        INVALIDATE_KEYS_ON_EXERCISE_LIST_UPDATE.forEach((queryKey) => {
          queryClient.invalidateQueries({
            queryKey: [queryKey],
            exact: false,
          });
        });
      },
    },
  });
}
